"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/no-array-index-key */
var material_1 = require("@mui/material");
var react_1 = require("react");
function ButtonAction(_a) {
    var actions = _a.actions, label = _a.label;
    var _b = __read((0, react_1.useState)(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ id: "actionbutton", "aria-controls": open ? 'basic-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, variant: "outlined", color: "darkGrey" }, { children: label })), (0, jsx_runtime_1.jsx)(material_1.Menu, __assign({ id: "action-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, { children: actions.map(function (action, index) {
                    return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ onClick: function () {
                            handleClose();
                            action.onClick();
                        } }, { children: action.label }), "menuItem".concat(index)));
                }) }))] }));
}
exports.default = ButtonAction;
ButtonAction.defaultProps = {
    label: 'ActionButton',
};
//# sourceMappingURL=ButtonAction.js.map